import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Categories from "./components/Categories";
import Products from "./components/Products";
import Login from "./components/Login";
import Register from "./components/Register";
import Cart from "./components/Cart";
import CheckoutForm from "./components/CheckoutForm";
import Orders from "./components/Orders";
import Profile from "./components/Profile";
import Navbar from "./components/Navbar";
import SearchPage from "./components/SearchPage";
import Loyalty from "./components/Loyalty";
import Club from "./components/Club";
import RecuperarContrasena from "./components/RecuperarContrasena";
import ResetPassword from "./components/ResetPassword";
import "./styles/main.css";

const App = () => {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main className="content">
          <Routes>
            <Route path="/" element={<Categories />} />
            <Route path="/category/:id" element={<Products />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<CheckoutForm />} />
            <Route path="/mis-ordenes" element={<Orders />} /> 
            <Route path="/perfil" element={<Profile />} />
            <Route path="/buscar" element={<SearchPage />} />
            <Route path="/Loyalty" element={<Loyalty />} />
            <Route path="/club" element={<Club />} />
            <Route path="/recuperar" element={<RecuperarContrasena />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
